import React from "react";
import ViewClientTestimonial from "../component/ClientTestimonial/ViewClientTestimonial";

const ClientTestimonial = () => {
  return (
    <>
      <ViewClientTestimonial />
    </>
  );
};

export default ClientTestimonial;
